const getPageByUrl = (state, rawUrl = '') => {
  const { pages } = state
  const url = rawUrl.replace(/\//g, '')
  return pages.get(url) || {}
}

export default getPageByUrl
